import React from 'react';
import styled from 'styled-components';

import { Button, Modal } from 'components/bootstrap';
import type { Collection } from 'collections/types';

import EntitiesList from './EntitiesList/EntitiesList';

type Props = {
  collectionId: Collection['id'];
  onClose: () => void;
};

const StyledFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const AddEntitiesModal = ({ collectionId, onClose }: Props) => (
  <Modal show onHide={onClose} fullScreen>
    <Modal.Header>
      <Modal.Title>Add Content to Collection</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <EntitiesList collectionId={collectionId} />
    </Modal.Body>
    <Modal.Footer>
      <StyledFooter>
        <Button onClick={onClose}>Close</Button>
      </StyledFooter>
    </Modal.Footer>
  </Modal>
);

export default AddEntitiesModal;
